$(document).ready(function () {
  $('body').on('click', '.wp-element-button', function(e){
    e.preventDefault();
    var x = true;
    var parent = $(this).parents('.coupon');
    parent.find('.err-msg').remove();
    $('input').removeClass('inputerror');
    var discount = parent.find('#discount-input');
    if(discount.val().trim() == ''){
      discount.addClass('inputerror');
      discount.parent().append('<p class="err-msg">Please enter coupon code.</p>');
      x = false;
    } else {
      discount.removeClass('inputerror');
      discount.parent().find('.err-msg').remove();
    }
    if(x==false) {
      return false;
    }
    else{
      form.unbind('submit').submit();
    }
  });
});